import recruiterApi from "api/recruiter";
import useUser from "contexts/User/useUser";
import {useEffect, useRef, useState} from "react";
import {useLocation} from "react-router-dom";
import {useQuery} from "@tanstack/react-query";

const useTalentFinder = () => {
  const [page, setPage] = useState(0);
  const location = useLocation();
  const scroll = useRef<number>(0);
  const prevSearch = useRef(location.search);
  const prevPath = useRef(location.pathname);
  const user = useUser();

  // @ts-ignore
  const noAccess = user.isEnterprise && !user.hasTalentFinder && location.pathname !== "/employees";
  const isValidRoute = ["/talent", "/employees"].includes(location.pathname);

  const {data, isLoading: loading} = useQuery({
    queryKey: ["talents", location.pathname, page, location.search],
    queryFn: () => recruiterApi.getTalents(page + 1),
    enabled: isValidRoute && !noAccess,
    staleTime: 2 * 60 * 1000,
  });

  useEffect(() => {
    if (prevPath.current === location.pathname) return;
    prevPath.current = location.pathname;
    setPage(0);
    scroll.current = 0;
  }, [location.pathname]);

  useEffect(() => {
    if (prevSearch.current === location.search) return;
    prevSearch.current = location.search;
    if (!window.location.pathname.startsWith("/talent")) return;
    setPage(0);
    scroll.current = 0;
  }, [location.search]);

  return {
    loading,
    talents: data?.talents,
    page,
    pages: data?.pages ?? 0,
    setPage,
    scroll,
    total: data?.total ?? 0,
  };
};

export default useTalentFinder;
